import React from 'react';
import { business } from '../data/business';
import { membershipCopy } from '../data/membership';
import { heroImage } from '../data/gallery';
export function StructuredData() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'AutoWash',
    name: 'los BROTHERS',
    description: 'Professional deep car cleaning — exterior & interior specialists.',
    image: heroImage,
    telephone: '+14153684846',
    areaServed: 'San Francisco Bay Area, CA',
    availableLanguage: ['English', 'Spanish'],
    openingHours: 'Mo-Sa 08:00-18:00',
    sameAs: [business.instagramHref],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Monthly Membership Plans',
      itemListElement: membershipCopy.en.plans.map(plan => ({
        '@type': 'Offer',
        name: `${plan.name} Membership`,
        description: plan.features.join(', '),
        itemOffered: {
          '@type': 'Service',
          name: plan.optionLabel
        }
      }))
    }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(schema)
  }} data-id="element-393" data-mp="7tn8ag6xiog0" />;
}